import { getTvObject, tv } from '@costar-ui/cosmos';
import { baseTV, baseStyles } from './checkbox-base.styles.esm.js';
import { checkboxGroupStyles } from './checkbox-group.styles.esm.js';
import { focusRing } from '../../theme/styles/common.esm.js';

Object.keys(baseTV.variants.checkboxAlignment);
Object.keys(baseTV.variants.size);
var checkboxTV = getTvObject({
  extend: focusRing,
  base: ['flex', 'flex-shrink-0', 'items-center', 'justify-center', 'rounded-sm', 'bg-action-base', 'transition', 'border'],
  variants: {
    variant: {
      "default": 'rounded-sm',
      circle: 'rounded-full text-neutral-strong'
    },
    size: {
      inherit: ['size-e-1.0', 'min-w-e-1.0'],
      //xs: ['size-2.5', 'min-w-2.5'],
      //sm: ['size-3', 'min-w-3'],
      md: ['size-4', 'min-w-4']
      //lg: ['size-5', 'min-w-5'],
      //xl: ['size-6', 'min-w-6'],
      //'2xl': ['size-7', 'min-w-7'],
      //'3xl': ['size-8', 'min-w-8']
    },
    isSelected: {
      "false": ['border', 'border-action-neutral', 'bg-action-base', 'text-neutral-strong', 'group-pressed:border-selected'],
      "true": ['border-selected', 'bg-action-selected', 'text-on-action-selected', 'group-pressed:border-base-inverse']
    },
    isHovered: {
      "true": 'border-hover'
    },
    isDisabled: {
      "true": 'border-disabled bg-action-disabled text-on-action-disabled'
    },
    isFocused: {
      "true": 'border-focus'
    }
  },
  compoundVariants: [{
    size: 'inherit',
    checkboxAlignment: 'top',
    className: ''
  }, {
    isSelected: true,
    isFocused: true,
    className: ['border-focus-bold']
  }, {
    isSelected: true,
    isDisabled: true,
    className: ['border-disabled']
  },
  // {
  //   size: 'xs',
  //   checkboxAlignment: 'top',
  //   className: 'mt-e-0.25'
  // } as ComponentVariant,
  // {
  //   size: 'sm',
  //   checkboxAlignment: 'top',
  //   className: 'mt-e-0.25'
  // } as ComponentVariant,
  {
    size: 'md',
    checkboxAlignment: 'top',
    className: 'mt-1'
  }
  // {
  //   size: 'lg',
  //   checkboxAlignment: 'top',
  //   className: 'mt-1.5'
  // } as ComponentVariant,
  // {
  //   size: 'xl',
  //   checkboxAlignment: 'top',
  //   className: 'mt-1.5'
  // } as ComponentVariant,
  // {
  //   size: '2xl',
  //   checkboxAlignment: 'top',
  //   className: 'mt-1.5'
  // } as ComponentVariant,
  // {
  //   size: '3xl',
  //   checkboxAlignment: 'top',
  //   className: 'mt-1.5'
  // } as ComponentVariant
  ]
});
var base = {
  check: tv(checkboxTV),
  base: baseStyles,
  group: checkboxGroupStyles
};
var checkboxStyles = {
  base: base
};

export { checkboxStyles, checkboxTV };
//# sourceMappingURL=checkbox.styles.esm.js.map
